import React, { useContext } from "react";
import { CartContext } from "../Component/CartContext";
import productData from "../Datas/productData";
import "../css/cartpage.scss";
import { Link, useNavigate } from "react-router-dom";

const CartPage = () => {
  const navigate = useNavigate();
  const { cartItems, removeFromCart, updateQuantity } = useContext(CartContext);

  const getProductById = (id) => {
    return productData.find((product) => product.id === id);
  };

  const calculateTotal = () => {
    let total = 0;
    cartItems.forEach((item) => {
      const product = getProductById(item.id);
      if (product) {
        const price = parseFloat(product.price.replace(/,/g, ""));
        total += price * item.quantity;
      }
    });
    return total;
  };

  const subtotal = calculateTotal();

  const handleUpdateQuantity = (id, size, color, newQuantity) => {
    if (newQuantity > 0) {
      updateQuantity(id, size, color, newQuantity);
    }
  };

  const handleCheckout = () => {
    if (cartItems.length > 0) {
      navigate("/checkout");
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      alert("Your cart is empty");
    }
  };

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (cartItems.length === 0) {
    return (
      <div className="cart-page main">
        <div className="cart-page__empty">
          <h2>Your cart is empty</h2>
          <Link to="/shop" onClick={toTop} className="cart-page__continue">
            Continue shopping
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="cart-page main">
      <div className="cart-page__container">
        <h1 className="cart-page__title">Your Cart</h1>

        <div className="cart-page__progress">
          <div className="cart-page__progress-text">
            You are $87.05 from free shipping.
          </div>
          <div className="cart-page__progress-bar">
            <div
              className="cart-page__progress-fill"
              style={{ width: "30%" }}
            ></div>
          </div>
        </div>

        <div className="cart-page__header">
          <div className="cart-page__header-item">Product</div>
          <div className="cart-page__header-item">Price</div>
          <div className="cart-page__header-item">Quantity</div>
          <div className="cart-page__header-item">Total</div>
        </div>

        <div className="cart-page__items">
          {cartItems.map((item, index) => {
            const product = getProductById(item.id);
            if (!product) return null;

            const itemTotal = parseFloat(product.price) * item.quantity;

            return (
              <div
                key={`${item.id}-${item.size}-${item.color}-${index}`}
                className="cart-page__item"
              >
                <div className="cart-page__product">
                  <div className="cart-page__product-image">
                    <img src={product.image} alt={product.name} />
                  </div>
                  <div className="cart-page__product-info">
                    <h3>{product.name}</h3>
                    {item.size && <p>{item.size}</p>}
                    {item.color && <p>{item.color}</p>}
                    <button
                      className="cart-page__remove"
                      onClick={() =>
                        removeFromCart(item.id, item.size, item.color)
                      }
                    >
                      REMOVE
                    </button>
                  </div>
                </div>
                <div className="cart-page__price">${product.price}</div>
                <div className="cart-page__quantity">
                  <button
                    className="cart-page__qty-btn"
                    onClick={() =>
                      handleUpdateQuantity(
                        item.id,
                        item.size,
                        item.color,
                        item.quantity - 1
                      )
                    }
                  >
                    -
                  </button>
                  <input
                    type="number"
                    value={item.quantity}
                    min="1"
                    onChange={(e) =>
                      handleUpdateQuantity(
                        item.id,
                        item.size,
                        item.color,
                        parseInt(e.target.value)
                      )
                    }
                  />
                  <button
                    className="cart-page__qty-btn"
                    onClick={() =>
                      handleUpdateQuantity(
                        item.id,
                        item.size,
                        item.color,
                        item.quantity + 1
                      )
                    }
                  >
                    +
                  </button>
                </div>
                <div className="cart-page__total">${itemTotal.toFixed(2)}</div>
              </div>
            );
          })}
        </div>

        <div className="cart-page__footer">
          <div className="cart-page__note">
            <div className="cart-page__note-label">
              LEAVE A NOTE WITH YOUR ORDER
            </div>
            <textarea placeholder="Add a note to your order"></textarea>
          </div>
          <div className="cart-page__checkout">
            <div className="cart-page__subtotal">
              <span>Subtotal:</span>
              <span className="cart-page__subtotal-price">
                ${subtotal.toFixed(2)} USD
              </span>
            </div>
            <div className="cart-page__taxes">
              Taxes and shipping calculated at checkout
            </div>
            <div className="cart-page__checkout-info">
              <i className="fas fa-lock"></i>
              <span>Free returns • Package protection</span>
            </div>
            <button
              className="cart-page__checkout-btn"
              onClick={handleCheckout}
            >
              CHECKOUT • US${subtotal.toFixed(2)}
            </button>
            <div className="cart-page__checkout-notice">
              Checkout without free returns & package protection
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartPage;
